// extracted by mini-css-extract-plugin
export default {"keyValueBlock":"xifEL","image":"PVOsq"};